module.exports = __webpack_public_path__ + "static/media/5-questions.94bad023.jpg";